import { KeyValue } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
/*
 * Converts enum to an array of KeyValues
 * Takes an enum type argument.
 * Usage:
 *   enumDefinition | enumKeyValue
 * Example:
 *   {{ StatusEnum | enumKeyValue }}
 *   formats to: [ { key: "Active", value: 1 }, { key: "Disabled", value: 2 } ]
*/
@Pipe({ name: 'enumKeyValue' })
export class EnumKeyValuePipe implements PipeTransform {
  transform(enumDefinition: any, orderBy: string): KeyValue<any, any>[] {
    let result = Object.keys(enumDefinition).filter(x => typeof enumDefinition[x as any] === "number").map(key => ({ key: key, value: enumDefinition[key] }));
    if (orderBy === "asc") {
      result = result.sort((a, b) => a.key.localeCompare(b.key));
    }
    else if (orderBy === "desc") {
      result = result.sort((a, b) => b.key.localeCompare(a.key));
    }
    return result;
  }
}